import React, { FC, useRef } from 'react';
import styled from 'styled-components/macro';

import media from 'helpers/media';

import Icon from 'components/Icon';
import NavigationItem from './item';

const NavItemRef = styled(NavigationItem)``;

const Wrapper = styled.div<{
    active?: boolean;
}>`
    .Dropdown_sc {
        display: none;
    }

    ${({ theme }) => media.fromLaptop`
        position: relative;
        display: flex;

        &:before {
            content: '';
            position: absolute;
            bottom: 10px;
            left: calc(50% - 9.5px);
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 9.5px 8px 9.5px;
            border-color: transparent transparent rgba(255, 255, 255, 0.9)
                transparent;
        }

        .Dropdown_sc {
            position: absolute;
            right: 0;
            width: 250px;
            top: 60px;
            padding: 16px 8px;
            background-color: rgba(255, 255, 255, 0.9);

            ${NavItemRef} & {
                padding-top: ${theme.space.small};
                padding-bottom: ${theme.space.small};
                color: ${theme.colors.body};
            }
        } 

        .Chevron_sc {
            margin-left: ${theme.space.small};
        }


        &:before, 
        & .Dropdown_sc {
            display: none;
        }

        &:hover:before,
        &:hover .Dropdown_sc {
            display: block;
        }
    `}

    ${media.toTablet`
        & .Chevron_sc {
            margin-left: auto;
        }

        & .Dropdown_opened .Chevron_sc {
            transform: rotate(180deg);
        }

        & .Dropdown_opened + .Dropdown_sc {
            display: block;
        }
    `}
`;

const NavigationDropdown: FC<
    {
        label: string;
        itemChildren?: React.ReactNode;
    } & React.HTMLAttributes<HTMLElement>
> = ({ label, itemChildren, ...rest }) => {
    const scrollRef = useRef<HTMLDivElement>(null);

    return (
        <Wrapper {...rest} ref={scrollRef}>
            <NavigationItem
                onClick={(e) => {
                    e.currentTarget.classList.toggle('Dropdown_opened');
                    scrollRef.current?.scrollIntoView({
                        behavior: 'smooth',
                    });
                }}
            >
                {itemChildren && itemChildren}
                <span>{label}</span>
                <Icon className="Chevron_sc" name="chevron_down" size={10} />
            </NavigationItem>
            <div className="Dropdown_sc">{rest.children}</div>
        </Wrapper>
    );
};

export default NavigationDropdown;
